// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__iMtZM","repositorio":"Footer_repositorio__o8IJk","link":"Footer_link__6kYcs","creditos":"Footer_creditos__Mfls8"};